import "./asnGRNViewDetails.css";
import React, { useState, useEffect, useRef } from "react";
import axios from "axios";
import jwt from "jwt-decode";
import { confirmAlert } from 'react-confirm-alert';
import { useNavigate } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import { UnloadingDetailsPopover } from "./unloadingDetailsPopover";
import { OdoMeterPopover } from './odoMeterPopover';
import { useLocation } from 'react-router-dom';
import { GET_CONFIGURATION_VALUES, GET_STAKEHOLDER_CATEGORY, TRIP_END_READING, PRINT_DOWNLOAD_DATA, UPDATE_UNLOADING_DATA, ISSUE_GRN_AND_INVOICE, SAVE_QUALITY_INSPECTION, GET_MEASUREMENT_LOT_DETAILS_BY_CONSIGNMENT, SEND_TO_QUALITY, UPDATE_UNLOADING, GET_USER_DETAILS } from '../../../common/URLs';
import Snackbar from '@mui/material/Snackbar';
import { PROD, PIT_ROLES } from "../../../common/constants";
import MuiAlert from '@mui/material/Alert';
import { ConfirmPopover } from '../../../preregcamps/confirmPopover/confirmPopover';
import { loaderService } from "../../../common/custom-loader/loader-service";
import { getLocalStorageItem } from "../../../common/localStorageUtils";
import { userData } from '../../../common/spinLoader';
import { toast } from 'react-toastify';
import { Fab, Typography, Container, Card, CardContent, Box, Grid, TextField, Button } from '@mui/material';
import { DataGrid, GridColDef, GridColumnGroupingModel } from '@mui/x-data-grid';
import { QuickSearchToolbar } from "../../../payment/common/commonFunctions";
import { KeyboardArrowLeftRounded } from '@mui/icons-material';
import Badge from 'react-bootstrap/Badge';
import { VALIDATION, capitalizeFunction, weightValidation } from "../../../common/commonValidations";
import { ConfirmationPopover } from "../../../common/commonPopovers/confirmationPopover";
import { FileUploadMUI } from "../../../common/fileUpload/fileUploadMUI";
import { handleNumberFieldFocus } from "../../../common/commonFunction";
import BadgeComponent from "../../../common/badge";
import apiClient from "../../../axios";

const Alert = React.forwardRef(function Alert(props, ref) {
    return <MuiAlert elevation={6} ref={ref} variant="filled" {...props} />;
})


export function AsnProceed() {
    const checkDev = process.env.REACT_APP_ENV === "developement local" || process.env.REACT_APP_ENV === "developement" || process.env.REACT_APP_ENV === "test" || process.env.REACT_APP_ENV === "test local" || process.env.REACT_APP_ENV === "production"
    const role = localStorage.getItem('role');
    const isWeighbridgeOperatorRole = [PIT_ROLES?.PitWeighbridgeOperator, PIT_ROLES?.PitManualWeighbridgeOperator].includes(role);
    const userLoggedInRole = userData?.user?.userRoles?.[0]?.roleName;
    const [characterLimit] = useState(500);
    const [addComment, setAddComment] = useState('');
    const navigate = useNavigate();
    const decoded = jwt(getLocalStorageItem('id_token'));
    const { state } = useLocation();
    const consignmentData = useLocation().state?.consignmentDetails;


    const [commentRows] = useState([
        { action: "Consignment Creation", comment: consignmentData.consignmentComments, isValueThere: consignmentData.consignmentComments ? true : false },
        { action: "Pick-up", comment: consignmentData.pickupComments, isValueThere: consignmentData.pickupComments ? true : false },
        { action: "Trip Start", comment: consignmentData.tripStartComments, isValueThere: consignmentData.tripStartComments ? true : false },
        { action: "Measurement", comment: consignmentData.measurementComments, isValueThere: consignmentData.measurementComments ? true : false },
        { action: "Unloading", comment: consignmentData.unloaderComments, isValueThere: consignmentData.unloaderComments ? true : false },
        { action: "Generate GRN", comment: consignmentData.destinationComments, isValueThere: consignmentData.destinationComments ? true : false }
    ])
    const commentColumns = [
        { field: "action", headerName: "Action", width: 200 },
        { field: "comment", headerName: "Comment", width: 400 }
    ]
    const [deliveryMeasurements, setDeliveryMeasurements] = useState({});
    const [consignmentLotDetails, setConsignmentLotDetails] = useState({});
    const [openSnackbar, setOpenSnackbar] = React.useState(false);
    const [alertMessage, setAlertMessage] = React.useState("");
    const [qualityRequest, setQualityRequest] = React.useState({})
    const [configLimitWeight, setConfigLimitWeight] = React.useState(0);
    const [configLimitMoisture, setConfigLimitMoisture] = React.useState(0);
    const [showPrintDownload, setShowPrintDownload] = React.useState(false);
    const [accountName, setAccountName] = useState();
    const [errorMessage, setErrorMessage] = useState({
        grossWeightError: "",
        tareWeightError: "",
        grossWeightDocError: "",
        tareWeightDocError: ""
    });
    const [documentsArray, setDocumentsArray] = useState([]);
    const [grossWeightDocList, setGrossWeightDocList] = useState([]);
    const [tareWeightDocList, setTareWeightDocList] = useState([]);
    const [logModalOpen, setLogModalOpen] = useState(false);
    const [cofirmMessage, setConfirmMessage] = useState("");
    const [getTolerance, setGetTolerance] = useState([]);
    const [downloadAsn, setDownloadAsn] = useState();
    const [role1, setRole1] = useState(false);
    const [role2, setRole2] = useState(false);
    const [tripEndedFlag, setTripEnded] = useState(false);
    const [stakeholderDetails, setStakeholderDetails] = useState();
    const [logModalOpen2, setLogModalOpen2] = useState(false);
    const [cofirmMessageUnloading, setConfirmMessageUnloading] = useState("");

    const [confirmOpen, setConfirmOpen] = useState(false);
    const handleConfirmOpen = () => setConfirmOpen(true);
    const handleConfirmClose = () => setConfirmOpen(false);

    const [confirmOpen2, setConfirmOpen2] = useState(false);
    const handleConfirmOpen2 = () => setConfirmOpen2(true);
    const handleConfirmClose2 = () => setConfirmOpen2(false);

    const [confirmOpen3, setConfirmOpen3] = useState(false);
    const handleConfirmOpen3 = () => setConfirmOpen3(true);
    const handleConfirmClose3 = () => setConfirmOpen3(false);

    useEffect(() => {
        setTripEnded(consignmentData?.consignmentMilestones?.[0]?.eventStatus === "TripEnded" ? true : false)
        if (userLoggedInRole) {
            if (userLoggedInRole === PIT_ROLES.PitWeighbridgeOperator) {
                setRole1(true);
            }
            if (userLoggedInRole === PIT_ROLES.PitUnloader) {
                setRole2(true);
            }
        } else {
            getStakeDetails();
        }
        getConsignmentLotDetails();
        toleranceLimit();
        setDeliveryMeasurements({
            destinationGrossWeight: consignmentData?.destinationGrossWeight ? (Number(consignmentData?.destinationGrossWeight) * 1000).toFixed(4) : '',
            destinationTareWeight: consignmentData?.destinationTareWeight ? (Number(consignmentData?.destinationTareWeight) * 1000).toFixed(4) : '',
            destinationNetWeight: consignmentData?.destinationNetWeight ? (Number(consignmentData?.destinationNetWeight) * 1000).toFixed(4) : '',
            destinationMoisture: consignmentData?.destinationTotalMoisture,
            deviationMoisture: consignmentData?.deviationMoisture,
            deviationWeight: consignmentData?.deviationWeight,
            destinationComments: consignmentData?.destinationComments,
            deviationWeightPercent: consignmentData?.isMeasurementDone === true ? consignmentData?.deviationWeightPercent : deliveryMeasurements.deviationWeightPercent = ((((consignmentData?.destinationGrossWeight - consignmentData?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs?.[0]?.inventoryDetails?.pickupWeight) / consignmentData?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs?.[0]?.inventoryDetails?.pickupWeight) * 100) * 100) / 100,
            deviationMositurePercent: consignmentData?.isMeasurementDone === true ? consignmentData?.deviationMositurePercent : deliveryMeasurements.deviationMositurePercent = ((((consignmentData?.destinationTotalMoisture - consignmentData?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs?.[0]?.inventoryDetails?.pickupMoisture) / consignmentData?.consignmentSourceDetails?.[0]?.consignmentPickupRbCbs?.[0]?.inventoryDetails?.pickupMoisture) * 100) * 100) / 100,

        })
        PIT_ROLES.PitWeighbridgeOperator === localStorage.getItem('role') && setAddComment(consignmentData?.measurementComments);
    }, [])

    const getStakeDetails = () => {
        loaderService.showLoader()
        apiClient
            .post(GET_STAKEHOLDER_CATEGORY,
                {
                    "urn": decoded.extension_URN,
                    "type": ""
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setStakeholderDetails(response.data);
                if (response?.data?.category === consignmentData?.consignmentDestinationType) {
                    setRole1(true)
                }
                loaderService.hideLoader()
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader()
            });
    }


    const updateBundleData = (data) => {
        let lotList = consignmentLotDetails?.inventoryList
        lotList?.forEach(lot => {
            if (lot.id === data.id) {
                lot.arrivalWeight = data.arrivalWeight;
                lot.arrivalMoisture = data.arrivalMoisture;
                lot.isRestrictedInventory = data.isRestrictedInventory;
                lot.isUnrestrictedInventory = data.isUnrestrictedInventory;
                lot.isScrapInventory = data.isScrapInventory;
            }

        })

        setConsignmentLotDetails({ ...consignmentLotDetails, inventoryList: lotList });
    }

    const onClickEdit = (row) => {

        confirmAlert({

            customUI: ({ onClose }) => {

                return (

                    <UnloadingDetailsPopover callBack={updateBundleData} bundleData={row} onClose={onClose} />

                );

            }

        });
    }

    const [acceptingInput, setAcceptingInput] = useState(false);
    const timeoutRef = useRef(null);

    const handleKeyDown = (e) => {
        console.log("e.key", e.key)
        console.log("e.code", e.code)
        if (e.key === 'Backspace') {
            e.preventDefault();
        }
        if (e.code !== "" || ((/[0-9]$/.test(e.key) == false) && e.key !== ".")) {
            e.preventDefault();
        }
    };

    const handleChange = (e) => {
        let totalLotWeight = consignmentLotDetails?.inventoryList.reduce(
            (total, e) => Number(e.pickupWeight) + total,
            0
        );

        let avgMoisture = deliveryMeasurements?.destinationMoisture;

        if (getLocalStorageItem("role") === PIT_ROLES?.PitWeighbridgeOperator) {
            if (e.target.name === "destinationTareWeight") {
                console.log("tareWeight", e.target.value);
                deliveryMeasurements.destinationNetWeight = Number(
                    deliveryMeasurements.destinationGrossWeight - e.target.value
                ).toFixed(4);

                let destinationNetWeightMT = deliveryMeasurements.destinationNetWeight / 1000;

                deliveryMeasurements.deviationWeight =
                    destinationNetWeightMT - totalLotWeight;
                deliveryMeasurements.deviationWeightPercent =
                    (((destinationNetWeightMT - totalLotWeight) / totalLotWeight) * 100);
                deliveryMeasurements.deviationMoisture =
                    (((deliveryMeasurements.destinationMoisture - avgMoisture) /
                        consignmentData.totalMoisture) *
                        100);
                deliveryMeasurements.deviationMositurePercent =
                    (((consignmentData?.destinationTotalMoisture - avgMoisture) /
                        avgMoisture) *
                        100);
                setErrorMessage({ ...errorMessage, tareWeightError: "" });
            }

            if (e.target.name === "destinationGrossWeight") {
                console.log("grossWeight", e.target.value);
                deliveryMeasurements.destinationNetWeight =
                    deliveryMeasurements.destinationTareWeight &&
                    Number(
                        e.target.value - deliveryMeasurements.destinationTareWeight
                    ).toFixed(4);

                let destinationNetWeightMT = deliveryMeasurements.destinationNetWeight / 1000;

                deliveryMeasurements.deviationWeight =
                    destinationNetWeightMT - totalLotWeight;
                deliveryMeasurements.deviationWeightPercent =
                    (((destinationNetWeightMT - totalLotWeight) / totalLotWeight) * 100);
                deliveryMeasurements.deviationMoisture =
                    (((deliveryMeasurements.destinationMoisture - avgMoisture) /
                        consignmentData.totalMoisture) *
                        100);
                deliveryMeasurements.deviationMositurePercent =
                    (((deliveryMeasurements.destinationMoisture - avgMoisture) /
                        avgMoisture) *
                        100);
                setErrorMessage({ ...errorMessage, grossWeightError: "" });
            }
        } else {
            if (e.target.name === "destinationTareWeight") {
                deliveryMeasurements.destinationNetWeight = Number(
                    deliveryMeasurements.destinationGrossWeight - e.target.value
                ).toFixed(4);

                let destinationNetWeightMT = deliveryMeasurements.destinationNetWeight / 1000;

                deliveryMeasurements.deviationWeight =
                    destinationNetWeightMT - totalLotWeight;
                deliveryMeasurements.deviationWeightPercent =
                    (((destinationNetWeightMT - totalLotWeight) / totalLotWeight) * 100);
                deliveryMeasurements.deviationMoisture =
                    (((deliveryMeasurements.destinationMoisture - avgMoisture) /
                        consignmentData.totalMoisture) *
                        100);
                deliveryMeasurements.deviationMositurePercent =
                    (((consignmentData?.destinationTotalMoisture - avgMoisture) /
                        avgMoisture) *
                        100);
                setErrorMessage({ ...errorMessage, tareWeightError: "" });
            }

            if (e.target.name === "destinationGrossWeight") {
                console.log("grossWeight", e.target.value);
                deliveryMeasurements.destinationNetWeight =
                    deliveryMeasurements.destinationTareWeight &&
                    Number(
                        e.target.value - deliveryMeasurements.destinationTareWeight
                    ).toFixed(4);

                let destinationNetWeightMT = deliveryMeasurements.destinationNetWeight / 1000;

                deliveryMeasurements.deviationWeight =
                    destinationNetWeightMT - totalLotWeight;
                deliveryMeasurements.deviationWeightPercent =
                    (((destinationNetWeightMT - totalLotWeight) / totalLotWeight) * 100);
                deliveryMeasurements.deviationMoisture =
                    (((deliveryMeasurements.destinationMoisture - avgMoisture) /
                        consignmentData.totalMoisture) *
                        100);
                deliveryMeasurements.deviationMositurePercent =
                    (((deliveryMeasurements.destinationMoisture - avgMoisture) /
                        avgMoisture) *
                        100);
                setErrorMessage({ ...errorMessage, grossWeightError: "" });
            }
        }

        if (e.target.name === "destinationMoisture") {
            deliveryMeasurements.deviationMoisture =
                e.target.value - avgMoisture;
            deliveryMeasurements.deviationMositurePercent =
                (((e.target.value - consignmentData?.totalMoisture) /
                    consignmentData?.totalMoisture) *
                    100);
        }

        let weightDeviation =
            deliveryMeasurements.destinationNetWeight / 1000 - totalLotWeight; //  NetWeight now in MT
        let lotsList = consignmentLotDetails?.inventoryList;
        let splitVal = 0;

        if (
            deliveryMeasurements.deviationWeightPercent &&
            (deliveryMeasurements.deviationWeightPercent > configLimitWeight ||
                deliveryMeasurements.deviationWeightPercent < -configLimitWeight)
        ) {
            if (deliveryMeasurements.deviationWeight != null && lotsList?.length > 0) {
                splitVal = ((weightDeviation / lotsList?.length) * 100) / 100;
            }
            lotsList?.forEach((lot) => {
                lot.isRestrictedInventory = true;
                lot.isUnrestrictedInventory = false;
                lot.arrivalWeight =
                    lot.pickupWeight +
                    lot.pickupWeight *
                    (deliveryMeasurements?.deviationWeightPercent / 100);
            });
        } else if (
            deliveryMeasurements.deviationWeightPercent <= configLimitWeight ||
            deliveryMeasurements.deviationWeightPercent >= -configLimitWeight
        ) {
            if (deliveryMeasurements.deviationWeight != null && lotsList?.length > 0) {
                splitVal = ((weightDeviation / lotsList?.length) * 100) / 100;
            }
            lotsList?.forEach((lot) => {
                lot.isRestrictedInventory = false;
                lot.isUnrestrictedInventory = true;
                lot.arrivalWeight =
                    lot.pickupWeight +
                    lot.pickupWeight *
                    (deliveryMeasurements?.deviationWeightPercent / 100);
            });
        }

        if (
            deliveryMeasurements.deviationMositurePercent &&
            (deliveryMeasurements.deviationMositurePercent > configLimitMoisture ||
                deliveryMeasurements.deviationMositurePercent < -configLimitMoisture)
        ) {
            if (deliveryMeasurements.deviationMoisture != null && lotsList?.length > 0) {
                splitVal = ((deliveryMeasurements.deviationMoisture / lotsList?.length) * 100) / 100;
            }
            lotsList?.forEach((lot) => {
                lot.arrivalMoisture =
                    lot.pickupMoisture +
                    deliveryMeasurements.deviationMositurePercent / 100;
            });
        } else if (
            deliveryMeasurements.deviationMositurePercent &&
            (deliveryMeasurements.deviationMositurePercent <= configLimitMoisture ||
                deliveryMeasurements.deviationMositurePercent >= -configLimitMoisture)
        ) {
            if (deliveryMeasurements.deviationMoisture != null && lotsList?.length > 0) {
                splitVal = ((deliveryMeasurements.deviationMoisture / lotsList?.length) * 100) / 100;
            }
            lotsList?.forEach((lot) => {
                lot.arrivalMoisture =
                    lot.pickupMoisture +
                    deliveryMeasurements.deviationMositurePercent / 100;
            });
        }

        setConsignmentLotDetails(consignmentLotDetails);

        if (e.target.name === "destinationComments") {
            setDeliveryMeasurements({ ...deliveryMeasurements, [e.target.name]: e.target.value });
            return;
        }

        if (getLocalStorageItem("role") === PIT_ROLES?.PitWeighbridgeOperator) {
            weightValidation(e.target.value) &&
                setDeliveryMeasurements({
                    ...deliveryMeasurements,
                    [e.target.name]: Number(e.target.value),
                });
        } else {
            weightValidation(e.target.value) &&
                setDeliveryMeasurements({
                    ...deliveryMeasurements,
                    [e.target.name]: Number(e.target.value),
                });
        }
    };

    const handleChangeQuality = (e) => {
        setQualityRequest({ ...qualityRequest, [e.target.name]: Number(e.target.value) });
    }

    const toleranceLimit = () => {
        loaderService.showLoader();
        apiClient
            .post(
                GET_CONFIGURATION_VALUES,
                {
                    "serviceType": "QualityToleranceLimit"
                },
                {
                    headers: {
                        Authorization: "Bearer " + getLocalStorageItem('id_token'),
                    },
                }
            )
            .then((response) => {
                const configList = response?.data?.configurationDetailList || [];
                setGetTolerance(configList);
                configList.forEach((tl) => {
                    const appKey = tl.appKey?.toLowerCase();
                    if (appKey === "weight") {
                        setConfigLimitWeight(Number(tl.value) || 0);
                    }
                    if (appKey === "moisture") {
                        setConfigLimitMoisture(Number(tl.value) || 0);
                    }
                });
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log("axiosERROR", error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    };

    const saveQualityMeasurements = (doneFlag) => {
        let lotList = [];
        consignmentLotDetails.inventoryList.forEach(lot => {
            lotList.push({
                "inventoryId": lot.id,
                "materialType": lot.materialType,
                "lotId": lot.id,
                "bundleId": lot.bundleId,
                "isRestrictedInventory": lot.isRestrictedInventory,
                "isUnrestrictedInventory": lot.isUnrestrictedInventory,
                "isScrapInventory": lot.isScrapInventory,
                "totalQuantity": lot.arrivalWeight,
                "totalMoisture": lot.arrivalMoisture,
                "unrestrictedWithoutDeviation": 0,
                "unrestrictedWeight": lot.isUnrestrictedInventory ? lot.arrivalWeight : 0,
                "unrestrictedMoisture": lot.isUnrestrictedInventory ? lot.arrivalMoisture : 0,
                "restrictedWithoutDeviation": 0,
                "restrictedWeight": lot.isRestrictedInventory ? lot.arrivalWeight : 0,
                "restrictedMoisture": lot.isRestrictedInventory ? lot.arrivalMoisture : 0,
                "scrap": 0,
                "scrapWeight": lot.isScrapInventory ? lot.arrivalWeight : 0,
                "scrapMoisture": lot.isScrapInventory ? lot.arrivalMoisture : 0,
                "categorizationLead1": "",
                "categorizationLead2": "",
                "heapNumber": "",
                "heapBarcodeNumber": "",
                "chippingDate": "",
                "inventoryChippingInstructionMappingId": ""
            })
        })
        let requestData = {
            ...qualityRequest,
            "consignmentId": consignmentData.id,
            "consignmentNo": consignmentData.consignmentNo,
            "qualityInspectionDoneFlag": doneFlag,
            "grossWeightFileId": documentsArray?.find((item) => item.documentType === "GrossWeight")?.documentBlobName,
            "grossWeightFileName": documentsArray?.find((item) => item.documentType === "GrossWeight")?.documentName,
            "containerName": "pit",
            "tareWeightFileId": documentsArray?.find((item) => item.documentType === "TareWeight")?.documentBlobName,
            "tareWeightFileName": documentsArray?.find((item) => item.documentType === "TareWeight")?.documentName,
            "lstCategorization": lotList

        }
        console.log("requestData", requestData)
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        apiClient
            .post(SAVE_QUALITY_INSPECTION, requestData, { headers })
            .then(res => {
                toast.success(res.data.message);
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
            });

    }

    const getConsignmentLotDetails = () => {
        let requestData = {
            "consignmentNo": consignmentData?.consignmentNo,
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(GET_MEASUREMENT_LOT_DETAILS_BY_CONSIGNMENT, requestData, { headers })
            .then(res => {
                setConsignmentLotDetails(res.data)
                const tempArr = []
                if (res.data.grossWeightFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "GrossWeight",
                        documentName: res.data.grossWeightFileName,
                        documentBlobName: res.data.grossWeightFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    })
                }
                if (res.data.tareWeightFileId) {
                    tempArr.push({
                        id: null,
                        documentType: "TareWeight",
                        documentName: res.data.tareWeightFileName,
                        documentBlobName: res.data.tareWeightFileId,
                        documentPath: null,
                        documentContainerName: "pit",
                        isActive: 1
                    })
                }
                setDocumentsArray(tempArr);
                loaderService.hideLoader();
            })

            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
                loaderService.hideLoader();
            });
    }

    const sendToQuality = () => {
        let requestData = {
            "consignmentNo": consignmentData?.consignmentNo,
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        axios
            .post(SEND_TO_QUALITY, requestData, { headers })
            .then(res => {
                toast.success(res.data.message)
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
            });
    }

    useEffect(() => {
        getUserDetails();
    }, []);

    function getUserDetails() {
        apiClient
            .post(GET_USER_DETAILS,
                {
                    "emailAddress": localStorage.getItem('InspectorEmail')
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                setAccountName(response.data.user.firstname + " " + response.data.user.middlename + " " + response.data.user.lastname)
            })
            .catch(function (error) {
                console.log(error);
            });
    }

    const [isApiCalled, setIsApiCalled] = useState(false);

    const onConfirmCreateGrn = async () => {
        if (isApiCalled) return;
        setIsApiCalled(true);
        try {
            await issueInvoice();
            await new Promise((resolve) => setTimeout(resolve, 1000));
        } catch (error) {
            console.error("API failed:", error);
        } finally {
            setConfirmOpen3(false);
            setIsApiCalled(false);
        }
    };

    const onCreateGrnButtonClick = (e) => {
        handleConfirmOpen3();
    }

    const issueInvoice = (e) => {
        let requestData = {
            "consignmentNo": consignmentData?.consignmentNo,
            "roleName": decoded.extension_URN ? "stakeholder" : userLoggedInRole,
            "userName": decoded.extension_URN ? decoded.extension_URN : accountName
        }
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(ISSUE_GRN_AND_INVOICE, requestData, { headers })
            .then(res => {
                if (res.data.isSuccess) {
                    setShowPrintDownload(true)
                    toast.success(res?.data?.message)
                    getConsignmentLotDetails();
                    navigate('../asnGRN', { state: { tabValue: state?.tabValue } })
                }
                else toast.error(res?.data?.message ? res?.data?.message : "Error")
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
                loaderService.hideLoader();
            });
    }

    const onConfirmSave = (e) => {
        handleConfirmClose();
        saveDeliveryMeasurements(e);
    }

    const onSaveButtonClick = (e) => {
        if ((!(deliveryMeasurements?.destinationGrossWeight) || Number(deliveryMeasurements?.destinationGrossWeight) === 0)) {
            toast.error("Please enter Gross Weight")
            setErrorMessage({ ...errorMessage, grossWeightError: "Please enter Gross weight" })
        }
        else if (consignmentData?.isUnloadingDone === true && (!(deliveryMeasurements?.destinationTareWeight) || Number(deliveryMeasurements?.destinationTareWeight) === 0)) {
            toast.error("Please enter Tare Weight")
            setErrorMessage({ ...errorMessage, tareWeightError: "Please enter Tare weight" })
        }
        else {
            handleConfirmOpen();
        };
    }

    const saveDeliveryMeasurements = (unloadingDone) => {
        const grossDisable = !((getLocalStorageItem('role') === PIT_ROLES.PitWeighbridgeOperator || getLocalStorageItem('role') === PIT_ROLES?.PitManualWeighbridgeOperator) && consignmentData?.isUnloadingDone != true) || (PIT_ROLES.PitScmUser != getLocalStorageItem('role') && !consignmentData?.isUnloadingAllowed)
        const tareDisable = !((localStorage.getItem('role') === PIT_ROLES.PitWeighbridgeOperator || getLocalStorageItem('role') === PIT_ROLES?.PitManualWeighbridgeOperator) && consignmentData?.isUnloadingDone === true) || (PIT_ROLES.PitScmUser != localStorage.getItem('role') && !consignmentData?.isUnloadingAllowed)
        let lotList = [];
        consignmentLotDetails.inventoryList.forEach(lot => {
            lotList.push({
                "consignmentId": consignmentData?.id,
                "bundleId": lot.bundleId,
                "arrivalWeight": lot.arrivalWeight,
                "arrivalMoisture": deliveryMeasurements?.destinationMoisture,
                "isRestrictedInventory": lot.isRestrictedInventory,
                "isUnrestrictedInventory": lot.isUnrestrictedInventory,
                "isScrapInventory": lot.isScrapInventory
            })
        })
        let requestData = {
            ...deliveryMeasurements,
            "destinationGrossWeight": deliveryMeasurements?.destinationGrossWeight ? Number(deliveryMeasurements?.destinationGrossWeight / 1000).toFixed(4) : null,
            "destinationTareWeight": deliveryMeasurements?.destinationTareWeight ? Number(deliveryMeasurements?.destinationTareWeight / 1000).toFixed(4) : null,
            "destinationNetWeight": deliveryMeasurements?.destinationNetWeight ? Number(deliveryMeasurements?.destinationNetWeight / 1000).toFixed(4) : null,
            "isDestinationGrossWeight": grossDisable ? false : true,
            "isDestinationTareWeight": tareDisable ? false : true,
            "isInPermissibleLimit": true,
            "isUnloadingDone": consignmentData?.isUnloadingDone,
            "deviationWeightPer": deliveryMeasurements?.deviationWeightPercent,
            "deviationMoisturePer": deliveryMeasurements?.deviationMositurePercent,
            "consignmentId": consignmentData?.id,
            "actualDeviationWeightPercent": configLimitWeight,
            "actualDeviationMoisturePercent": configLimitMoisture,
            "consignmentNo": consignmentData?.consignmentNo,
            "grossWeightFileId": documentsArray?.find((item) => item.documentType === "GrossWeight")?.documentBlobName,
            "grossWeightFileName": documentsArray?.find((item) => item.documentType === "GrossWeight")?.documentName,
            "containerName": "pit",
            "tareWeightFileId": documentsArray?.find((item) => item.documentType === "TareWeight")?.documentBlobName,
            "tareWeightFileName": documentsArray?.find((item) => item.documentType === "TareWeight")?.documentName,
            "isMeasurementDone": consignmentData?.isUnloadingDone === true ? true : false,
            "lstCategorization": lotList,
            "roleType": localStorage.getItem('role'),
            "measurementComments": addComment,
        }
        console.log("requestData", requestData)
        let headers = {
            Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
        }
        loaderService.showLoader();
        apiClient
            .post(UPDATE_UNLOADING_DATA, requestData, { headers })
            .then(res => {
                if(res.data.isSuccess === true) {
                toast.success(res.data.message);
                getConsignmentLotDetails();
                navigate('/asnGRN');
                }
                else {
                    toast.error(res.data.message)
                }
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                toast.error(error.message);
                loaderService.hideLoader();
            });

    }

    const onConfirmUnloadingDone = (e) => {
        handleConfirmClose2();
        unloadingDone();
    }

    const onUnloadingButtonClick = (e) => {
        handleConfirmOpen2();
    }

    const unloadingDone = () => {
        loaderService.showLoader();
        apiClient
            .post(UPDATE_UNLOADING,
                {
                    "consignmentId": consignmentData?.id,
                    "isUnloadingDone": true,
                    "unloaderComments": addComment
                },
                {
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),
                    }
                }, null
            )
            .then((response) => {
                toast.success(response.data.message);
                navigate('/asnGRN');
                loaderService.hideLoader();
            })
            .catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }


    const handleSnackbarClose = () => {
        setOpenSnackbar(false);
    };

    const getDownloadAsn = (action) => {
        loaderService.showLoader();
        axios
            .post(PRINT_DOWNLOAD_DATA,
                {
                    "printDataByNumber": consignmentData?.asnNo,
                    "printDetailsType": "asn",
                },
                {
                    responseType: 'blob',
                    headers: {
                        Authorization: 'Bearer ' + getLocalStorageItem('id_token'),

                        Accept: 'application/pdf'
                    }
                }, null
            )
            .then((response) => {
                setDownloadAsn(response.data);
                const url = URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));

                if (action === "download") {
                    const link = document.createElement("a");
                    link.href = url;
                    link.setAttribute(
                        "download",
                        `Output.pdf`
                    );
                    document.body.appendChild(link);

                    link.click();
                    link.parentNode.removeChild(link);
                }
                if (action === "print") {
                    let iframe = document.createElement('iframe');
                    document.body.appendChild(iframe);
                    iframe.style.display = 'none';
                    iframe.src = url;
                    iframe.onload = function () {
                        setTimeout(function () {
                            iframe.focus();
                            iframe.contentWindow.print();
                        }, 1);
                    };
                }
                loaderService.hideLoader();
            }).catch(function (error) {
                console.log(error);
                loaderService.hideLoader();
                toast.error(error.message);
            });
    }

    const onTextValueChange = (e) => {
        setAddComment(VALIDATION.noSpecialCharacterValidation(e.target.value.slice(0, 500)));
    }

    const columns: GridColDef[] = [
        { field: 'bundleId', headerName: 'Lot ID', width: 260 },
        {
            field: consignmentLotDetails?.totalMoisture,
            headerName: 'Moisture',
            width: 100,
            valueGetter: (params) => {
                return consignmentLotDetails.totalMoisture;
            }
        },
        {
            field: 'pickupWeight',
            headerName: 'Weight (in MT)',
            width: 130,
            valueGetter: (params) => params.value?.toFixed(4),
        },
        {
            field: 'destinationTotalMoisture',
            headerName: 'Moisture',
            width: 100,
            valueGetter: (params) => {
                return consignmentLotDetails.destinationTotalMoisture;
            }
        },
        {
            field: 'arrivalWeight',
            headerName: 'Weight (in MT)',
            width: 130,
            valueGetter: (params) => params.value?.toFixed(4),
        },
        {
            field: 'isUnrestrictedInventory',
            headerName: 'Un-Restricted Inventory',
            type: 'number',
            width: 180,
            valueFormatter: (params) => {
                if (params.value === false) {
                    return 'No';
                }
                else {
                    return 'Yes'
                }
            }
        },
        {
            field: 'isRestrictedInventory',
            headerName: 'Restricted Inventory',
            type: 'number',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === false) {
                    return 'No';
                }
                else {
                    return 'Yes'
                }
            }
        },
        {
            field: 'isScrapInventory',
            headerName: 'Scrap Inventory',
            type: 'number',
            width: 150,
            valueFormatter: (params) => {
                if (params.value === false) {
                    return 'No';
                }
                else {
                    return 'Yes'
                }
            }
        },
    ];

    const columnGroupingModel: GridColumnGroupingModel = [
        {
            groupId: 'Loading',
            children: [{ field: consignmentLotDetails?.totalMoisture }, { field: 'pickupWeight' }],
        },
        {
            groupId: 'Unloading',
            children: [{ field: 'destinationTotalMoisture' }, { field: 'arrivalWeight' }, { field: 'isUnrestrictedInventory' }, { field: 'isRestrictedInventory' }, { field: 'isScrapInventory' }],
        },
    ];

    const onUploadCallBack = (docArray) => {
        setDocumentsArray(docArray);
    }


    return (
        <>
            <Snackbar
                open={openSnackbar}
                autoHideDuration={6000}
                onClose={handleSnackbarClose}
                anchorOrigin={{
                    vertical: 'top',
                    horizontal: 'center',
                }}
            >
                <Alert

                    onClose={handleSnackbarClose}
                    severity="success"
                    sx={{ width: '100%' }}

                >
                    {alertMessage}
                </Alert>
            </Snackbar>

            <Container maxWidth="xxl">
                {!PROD && <p style={{ textAlign: "center", fontSize: "2vh" }}>PIT08</p>}
                <Typography variant="h4" sx={{ mb: 2 }}>
                    <Fab onClick={() => { navigate(-1) }} size="small" aria-label="back" title='Back'>
                        <KeyboardArrowLeftRounded />
                    </Fab> Weighbridge Measurement at Delivery Location
                </Typography>
                <Card>
                    <CardContent>
                        <Grid container spacing={1} direction="row" mt={1}>
                            <Grid item xs={12}>
                                <Grid container spacing={3}>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            error={errorMessage.grossWeightError}
                                            helperText={errorMessage.grossWeightError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label='Gross weight (in KG) measured'
                                            disabled={!((getLocalStorageItem('role') === PIT_ROLES.PitWeighbridgeOperator || getLocalStorageItem('role') === PIT_ROLES?.PitManualWeighbridgeOperator) && consignmentData?.isUnloadingDone != true) || (PIT_ROLES.PitScmUser != getLocalStorageItem('role') && !consignmentData?.isUnloadingAllowed)}
                                            name="destinationGrossWeight"
                                            onChange={(e) => handleChange(e)}
                                            value={deliveryMeasurements?.destinationGrossWeight || ''}
                                            inputProps={{
                                                maxLength: 8
                                            }}
                                            onKeyDown={(e) => {
                                                if (getLocalStorageItem('role') === PIT_ROLES?.PitWeighbridgeOperator) {
                                                    handleKeyDown(e);
                                                }
                                                else {
                                                    if (
                                                        e.key === 'e' ||
                                                        e.key === 'E' ||
                                                        e.key === '+' ||
                                                        e.key === '-'
                                                    ) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            }}
                                        />
                                        <BadgeComponent currentLength={deliveryMeasurements?.destinationGrossWeight?.toString()?.length} maxLength={8} />
                                        <FileUploadMUI key="AsnGrossWeight"
                                            documentList={documentsArray}
                                            documentType="GrossWeight"
                                            callBackDocumentUpload={onUploadCallBack}
                                            title="Gross weight document"
                                            containerName="pit"
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="grossWeightDocError"
                                            disabled={!((localStorage.getItem('role') === PIT_ROLES.PitWeighbridgeOperator || getLocalStorageItem('role') === PIT_ROLES?.PitManualWeighbridgeOperator) && consignmentData?.isUnloadingDone != true) || (PIT_ROLES.PitScmUser != localStorage.getItem('role') && !consignmentData?.isUnloadingAllowed)}
                                        />
                                        <div className='mandatory_field'>{errorMessage.grossWeightDocError}</div>

                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            error={errorMessage.tareWeightError}
                                            helperText={errorMessage.tareWeightError}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            disabled={!((localStorage.getItem('role') === PIT_ROLES.PitWeighbridgeOperator || getLocalStorageItem('role') === PIT_ROLES?.PitManualWeighbridgeOperator) && consignmentData?.isUnloadingDone === true) || (PIT_ROLES.PitScmUser != localStorage.getItem('role') && !consignmentData?.isUnloadingAllowed)}
                                            value={deliveryMeasurements?.destinationTareWeight || ''}
                                            label='Tare weight (in KG) measured'
                                            name="destinationTareWeight"
                                            onChange={(e) => handleChange(e)}
                                            inputProps={{
                                                maxLength: 8
                                            }}
                                            onKeyDown={(e) => {
                                                if (getLocalStorageItem('role') === PIT_ROLES?.PitWeighbridgeOperator) {
                                                    handleKeyDown(e);
                                                }
                                                else {
                                                    if (
                                                        e.key === 'e' ||
                                                        e.key === 'E' ||
                                                        e.key === '+' ||
                                                        e.key === '-'
                                                    ) {
                                                        e.preventDefault();
                                                    }
                                                }
                                            }}
                                        />
                                        <BadgeComponent currentLength={deliveryMeasurements?.destinationTareWeight?.toString()?.length} maxLength={8} />
                                        <FileUploadMUI key="AsnTareWeight"
                                            documentList={documentsArray}
                                            documentType="TareWeight"
                                            callBackDocumentUpload={onUploadCallBack}
                                            title="Tare weight document"
                                            containerName="pit"
                                            errorMessage={errorMessage}
                                            setErrorMessage={setErrorMessage}
                                            documentError="tareWeightDocError"
                                            disabled={!((isWeighbridgeOperatorRole) && consignmentData?.isUnloadingDone == true) || (PIT_ROLES.PitScmUser != localStorage.getItem('role') && !consignmentData?.isUnloadingAllowed)}
                                        />
                                        <div className='mandatory_field'>{errorMessage.tareWeightDocError}</div>

                                    </Grid>
                                    <Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            value={Number((deliveryMeasurements.destinationNetWeight)).toFixed(4) || ''}
                                            disabled
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label='Net weight(in KG) as per measurement'
                                            name="destinationNetWeight"
                                            onChange={(e) => handleChange(e)} />
                                    </Grid>
                                    <Grid item xs={12} lg={4}>

                                        <TextField fullWidth size="small"
                                            disabled={!(localStorage.getItem('role') === PIT_ROLES.PitWeighbridgeOperator && consignmentData?.isUnloadingDone != true) || (PIT_ROLES.PitScmUser != localStorage.getItem('role') && !consignmentData?.isUnloadingAllowed)}
                                            value={deliveryMeasurements?.destinationMoisture || ''}
                                            type="number"
                                            onFocus={handleNumberFieldFocus}
                                            label='Average Moisture'
                                            name="destinationMoisture"
                                            onChange={(e) => handleChange(e)}
                                            inputProps={{
                                                maxLength: 10,
                                            }}

                                            onKeyDown={(evt) => (evt.key === 'e' || evt.key === 'E' || evt.key === '-' || evt.key === '+') && evt.preventDefault()}
                                        />
                                    </Grid>

                                    {!consignmentData.isDbsAsn && <><Grid item xs={12} lg={4}>

                                        <TextField fullWidth size="small"
                                            label='Deviation Weight(in %)'
                                            value={Number(deliveryMeasurements?.deviationWeightPercent).toFixed(2)}
                                            disabled
                                            name="deviationWeight" />


                                    </Grid>
                                        <Grid item xs={12} lg={4}>

                                            <TextField fullWidth size="small"
                                                label='Deviation Moisture(in %)'
                                                value={Number(deliveryMeasurements?.deviationMositurePercent).toFixed(2)}
                                                disabled
                                                name="deviationMoisture" />
                                        </Grid></>}
                                    {consignmentData.isDbsAsn ? <><Grid item xs={12} lg={4}>
                                        <TextField fullWidth size="small"
                                            label='Lot ID'
                                            value={consignmentLotDetails?.inventoryList?.length > 0 ? consignmentLotDetails?.inventoryList[0]?.bundleId : ""}
                                            disabled />
                                    </Grid>
                                        <Grid item xs={12} lg={4}>
                                            <TextField fullWidth size="small"
                                                label='Barcode'
                                                value={consignmentLotDetails?.inventoryList?.length > 0 ? consignmentLotDetails?.inventoryList[0]?.barcodeNo : ""}
                                                disabled />
                                        </Grid></>
                                        : <Grid item xs={12} lg={12}>
                                            <Box style={{ height: 400, width: '100%' }}>
                                                {
                                                    consignmentLotDetails?.inventoryList &&
                                                    <DataGrid
                                                        experimentalFeatures={{ columnGrouping: true }}
                                                        columnGroupingModel={columnGroupingModel}
                                                        rows={consignmentLotDetails?.inventoryList}
                                                        columns={columns}
                                                        pageSize={10}
                                                        getRowId={(row) => row.bundleId}

                                                    />
                                                }
                                            </Box>
                                        </Grid>}
                                </Grid>

                            </Grid>
                        </Grid>

                        <Grid container mt={2}>
                            <Grid item xs={12} lg={6}>
                                <TextField fullWidth
                                    autoComplete="off"
                                    type='text'
                                    id="outlined-multiline-static"
                                    label="Comments"
                                    multiline
                                    rows={4}
                                    name="destinationComments"
                                    onChange={(e) => onTextValueChange(e)}
                                    value={addComment}
                                    sx={{ paddingRight: '15%' }}
                                />
                                <div style={{ display: 'flex', justifyContent: 'flex-end', paddingRight: '10%' }}>
                                    <Badge bg={`${addComment?.length > characterLimit ? 'danger' : 'primary'}`}>{addComment?.length}/{characterLimit}</Badge>
                                </div>
                            </Grid>
                            <Grid item xs={12}>
                                <Box style={{ height: 300, width: '100%' }}>
                                    <DataGrid
                                        rows={commentRows?.filter(item => item.isValueThere)}
                                        columns={commentColumns}
                                        pageSize={10}
                                        getRowId={(row) => row.action}
                                    />
                                </Box>
                            </Grid>
                        </Grid>

                    </CardContent>
                </Card>
                <Box display='flex' alignItems="center" justifyContent="center" mt={3} style={{ float: "right" }}>
                    {!(consignmentLotDetails?.consignmentStatus === "GRNandInvoiceGenerated") && !(consignmentLotDetails?.consignmentStatus === "GRNCompleted") && !(consignmentLotDetails?.consignmentStatus === "UnloadingCompleted") && (isWeighbridgeOperatorRole) &&

                        <Button sx={{ minWidth: 100 }} disabled={!consignmentData?.isUnloadingAllowed} variant="contained" onClick={(e) => onSaveButtonClick(e)}>Save</Button>

                    }
                    {
                        localStorage?.getItem('role') == PIT_ROLES.PitUnloader && consignmentData?.isUnloadingDone != true && (Number(deliveryMeasurements?.destinationGrossWeight) !== 0 || deliveryMeasurements?.destinationGrossWeight !== null) ?

                            <Button sx={{ minWidth: 100, ml: 1 }} variant="contained" disabled={!consignmentData?.isUnloadingAllowed} onClick={() => onUnloadingButtonClick()}>Unloading Done</Button>

                            : null
                    }

                    {(() => {
                        const role = localStorage.getItem('role');
                        const matType = consignmentData?.materialType?.toLowerCase();
                        const destType = consignmentData?.consignmentDestinationType;

                        const isRawBamboo = matType === "rawbamboo";
                        const isChipBamboo = matType === "chipbamboo";

                        const showForLLE =
                            stakeholderDetails &&
                            isRawBamboo &&
                            destType === "LLE";

                        const showForPlantScmOperator =
                            (role === PIT_ROLES.PlantSCMOperator || role === PIT_ROLES.PitScmUser) &&
                            isRawBamboo &&
                            destType === "Plant";

                        const showForPlantScmUser =
                            (role === PIT_ROLES.PlantSCMOperator || role === PIT_ROLES.PitScmUser) &&
                            isChipBamboo &&
                            destType === "Plant";

                        const shouldShowButton =
                            (showForLLE || showForPlantScmOperator || showForPlantScmUser) &&
                            !showPrintDownload &&
                            consignmentData?.isMeasurementDone === true &&
                            consignmentData?.isTripEnded &&
                            !(consignmentLotDetails?.consignmentStatus === "GRNandInvoiceGenerated") &&
                            !(consignmentLotDetails?.consignmentStatus === "GRNCompleted");

                        return shouldShowButton ? (
                            <Button
                                sx={{ minWidth: 100, ml: 1 }}
                                variant="contained"
                                onClick={(e) => onCreateGrnButtonClick(e)}
                                type="submit"
                            >
                                Create GRN
                            </Button>
                        ) : null;
                    })()}

                </Box>

            </Container>

            <ConfirmationPopover onOpen={confirmOpen} onConfirm={onConfirmSave} onClose={handleConfirmClose} action="Save" />
            <ConfirmationPopover onOpen={confirmOpen2} onConfirm={onConfirmUnloadingDone} onClose={handleConfirmClose2} action="Unloading Done" />
            <ConfirmationPopover onOpen={confirmOpen3} onConfirm={onConfirmCreateGrn} onClose={handleConfirmClose3} action="Create GRN" />

        </>
    )
}
